import { FilterDescriptor } from '@progress/kendo-data-query'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

interface NotificationTypeFilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

export const NotificationTypeFilter: React.FC<NotificationTypeFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const notificationTypes = useAppSelector((state) => state.clientArea.notificationTypes)

  const data = notificationTypes.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <SelectFilter
      placeholder='Notification Type'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
      style={{ width: 240 }}
    />
  )
}
